import React from 'react';
import { connect } from 'react-redux';
import Invoices from './Invoices';
import path from 'helpers/path';
import { WithRouterProps } from 'decorators/withRouter';
import { withRouter } from 'react-router-dom';
import { InvoicesWl19 } from './Invoices.wl19';
import { WL_ID_19 } from 'constants/wlIds';

interface OwnProps {
  isCreate?: boolean;
}

interface ConnectedProps {
  configuration: any;
  wlId: number | null;
}

type Props = OwnProps & ConnectedProps & WithRouterProps;

const InvoicesContainer: React.FC<Props> = ({
  configuration,
  isCreate,
  wlId,
  history,
}) => {
  if (!configuration) {
    return null;
  }
  if (wlId === WL_ID_19) {
    return <InvoicesWl19
      isCreate={Boolean(isCreate)}
      onCloseCreateModal={() => history.push(path('/invoices'))}
    />
  }

  return (
    <Invoices isCreate={Boolean(isCreate)} />
  );
};

const mapStateToProps = (state): ConnectedProps => ({
  configuration: state.configuration,
  wlId: state.settings.wlId,
});

export default withRouter(connect(mapStateToProps)(InvoicesContainer));
